export enum ControlsUserType {
    Tester = 10,
    Uploader = 20,
    Reviewer = 30,
    SourceDocUploader = 40
}
